import { useQuery } from '@tanstack/react-query';
import { fetchProfile } from '@/lib/api';
import type { UserProfile } from '@/lib/types';

export function useProfile() {
  return useQuery<UserProfile>({
    queryKey: ['me'],
    queryFn: fetchProfile,
    staleTime: 30_000,
  });
}
